<template>
  <div>
    <!-- Start form -->
    <div class="container-fluid py-5">
      <div class="row">
        <div class="col-12 col-md-8 mx-auto">
          <div class="lpg-form px-3">
            <form @submit.prevent="submit">
              <h2 class="mt-5  lpg-form-title">Registro de candidatos</h2>
              <h4 class="mt-4 mb-3 lpg-form-subtitle">Datos generales</h4>
              <!--put lpg-error class to input for validations -->
              <div class="row">
                <div class="col-12 col-lg-6">
                  <text-input
                    id="name"
                    v-model="form.name"
                    label="Nombre"
                    placeholder="Juan"
                    :required="true"
                    :error="errors.name"
                  >
                  </text-input>
                </div>
                <div class="col-12 col-lg-6">
                  <text-input
                    id="lastname"
                    v-model="form.lastname"
                    label="Apellido"
                    placeholder="Pérez"
                    :required="true"
                    :error="errors.lastname"
                  >
                  </text-input>
                </div>
              </div>
              <text-input
                id="dui"
                v-model="form.dui"
                label="DUI"
                placeholder="01234567-8"
                :required="true"
                :error="errors.dui"
              >
              </text-input>
              <text-input
                id="date_of_birth"
                v-model="form.date_of_birth"
                type="date"
                label="Fecha de nacimiento"
                :required="true"
                :error="errors.date_of_birth"
              >
              </text-input>
              <select-input
                id="gender"
                v-model="form.gender"
                label="Género"
                :required="true"
                :error="errors.gender"
              >
                <option value="" disabled>Seleccionar</option>
                <option v-for="(gender, key) in ['Femenino', 'Masculino', 'Otro']" :key="key">
                  {{ gender }}
                </option>
              </select-input>
              <text-input
                id="phone_number"
                type="tel"
                v-model="form.phone_number"
                label="Teléfono"
                placeholder="0000-0000"
                :error="errors.phone_number"
              >
              </text-input>
              <text-input
                id="email"
                v-model="form.email"
                type="email"
                label="Correo electrónico"
                placeholder="hola@example.com"
                :required="true"
                :error="errors.email"
              >
              </text-input>
              <text-input
                id="password"
                v-model="form.password"
                type="password"
                label="Contraseña"
                placeholder="*********"
                :required="true"
                :error="errors.password"
              >
              </text-input>
              <text-input
                id="password_confirmation"
                v-model="form.password_confirmation"
                type="password"
                label="Confirmar contraseña"
                placeholder="*********"
                :required="true"
                :error="errors.password_confirmation"
              >
              </text-input>
              <div class="mb-4">
                <div class="mt-5 mb-4 text-center">
                  <!-- for tag on label must equal to input file id tag -->
                  <label for="lpg-file-upload" class="lpg-file-upload">
                    <BS-Icon
                      :_class="[
                        'bi bi-file-earmark-check-fill',
                        { 'visually-hidden': form.cv_file === null },
                      ]"
                      _label="Archivo subido"
                      _style="color: #a7d129; font-size: 1.75rem"
                    />
                    {{ form.cv_file === null ? 'Adjuntar CV' : 'Reemplazar CV' }}
                  </label>
                  <input
                    type="file"
                    class="form-control form-control-lg"
                    id="lpg-file-upload"
                    placeholder="Adjuntar CV"
                    accept=".pdf"
                    @input="form.cv_file = $event.target.files[0]"
                  />
                  <p
                    v-if="form.cv_file && form.cv_file.name"
                    class="text-center text-secondary text-italic my-1"
                  >
                    {{ form.cv_file.name }}
                  </p>
                </div>
                <div>
                  <p class="d-block text-center text-danger fw-bold">
                    Formato admitido: PDF
                    <br />
                    Tamaño máximo admitido: 5MB
                  </p>
                </div>
              </div>
              <div class="mb-4 text-end">
                <button type="submit" class="btn btn-secondary mt-1" :disabled="form.progress">
                  <span
                    :class="{
                      'visually-hidden': !form.progress,
                      'spinner-border spinner-border-sm': form.progress,
                    }"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- End form -->
  </div>
</template>

<script>
import Layout from '@/Layouts/Layout'
import Icon from '@/Components/BS-Icon'
import TextInput from '@/Components/Form/TextInput'
import SelectInput from '@/Components/Form/SelectInput'

export default {
  name: 'RegistroCandidato',
  layout: Layout,
  components: { Icon, TextInput, SelectInput },
  props: {
    errors: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        lastname: '',
        dui: '',
        phone_number: '',
        date_of_birth: '',
        gender: '',
        email: '',
        password: '',
        password_confirmation: '',
        cv_file: null,
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/registro')
    },
  },
}
</script>
